    export interface IMarket {
        name: string;
        fullName: string;
        code: string;
        marketTypeCode: string;
        enabled: boolean;
        displayStartDate: Date;
        displayEndDate: Date;
        effectiveStartDate: Date;
        effectiveEndDate: Date;
        territoryId: number;
        stateCode: string;
    }

    export class Market implements IMarket {
        name: string;
        fullName: string;
        code: string;
        marketTypeCode: string;
        enabled: boolean;
        displayStartDate: Date;
        displayEndDate: Date;
        effectiveStartDate: Date;
        effectiveEndDate: Date;
        territoryId: number;
        stateCode: string;
    }